import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router, RouterModule, ActivatedRoute } from '@angular/router';
import { ButtonComponent } from '../button/button.component';
import { InputComponent } from '../input/input.component';
import { CommonService } from '../../services/common.service';
import { BuscaRedimeViveComponent } from '../busca-redime-vive/busca-redime-vive.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [ReactiveFormsModule,CommonModule, RouterModule, ButtonComponent, InputComponent, BuscaRedimeViveComponent, TranslateModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit {

  loginForm = new FormGroup({
    email: new FormControl('',[Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required, Validators.minLength(6)])
  })

  isLoading = false;
  errorMessage = '';
  showResendVerification = false;
  socialLoginLoading: string | null = null;
  socialLoginError = '';

  private readonly onPageShow = (e: PageTransitionEvent) => {
    if (e.persisted) {
      // Browser restored page from bfcache — reset loading state
      this.socialLoginLoading = null;
    }
  };

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private commonService: CommonService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    // Reset in case browser restored from bfcache
    this.socialLoginLoading = null;
    window.addEventListener('pageshow', this.onPageShow);
  }

  ngOnDestroy(): void {
    window.removeEventListener('pageshow', this.onPageShow);
  }

  onSubmit() {
    this.loginForm.markAllAsTouched();
    this.commonService.markFormGroupDirty(this.loginForm)
  
    if (this.loginForm.valid) {
      this.isLoading = true;
      this.errorMessage = '';
      const { email, password } = this.loginForm.value;
  
      if (!email || !password) return;
  
      this.authService.login(email, password).subscribe(
        (response) => {
          this.isLoading = false;
          const returnUrl = this.route.snapshot.queryParams['returnUrl'];
          
          if (returnUrl) {
            // navigateByUrl handles full URLs including query params
            this.router.navigateByUrl(returnUrl);
          } else {
            this.router.navigate(['']);
          }
        },
        (error) => {
          console.error('Error durante el inicio de sesión:', error);
          this.isLoading = false;
          this.errorMessage = error.error.message ?? 'Credenciales inválidas o error de conexión';
          // Show resend verification link on email not verified errors
          if (error.status === 401 && error.error?.message?.toLowerCase().includes('verif')) {
            this.showResendVerification = true;
          }
        }
      );
    }
  }

  onSocialLogin(provider: 'google' | 'facebook' | 'apple'): void {
    this.socialLoginLoading = provider;
    this.socialLoginError = '';
    this.authService.initSocialLogin(provider).subscribe({
      next: (response) => {
        window.location.href = response.redirectUrl;
      },
      error: (err) => {
        this.socialLoginLoading = null;
        this.socialLoginError = err?.error?.message ?? 'Error al iniciar sesión social. Intentá de nuevo.';
      }
    });
  }

}
